import { RootState } from "../reducers"

export const selectCurrentProduct = (state: RootState) =>
  state.store.currentProduct

export const selectCollectedProducts = (state: RootState) =>
  state.store.collectedProductIds
